module.exports = __webpack_public_path__ + "img/error.6eb0278a.svg";